import { gql } from "@apollo/client";

//returns a personIncidentSpecific
export const PERSON_INCIDENT_HISTORY = gql`
  query personIncidentHistory($personId: ID!, $originatorId: ID!) {
    personIncidentHistory(personId: $personId, originatorId: $originatorId) {
      id
      incident {
        id
        sealed
        locked
        address {
          id
          name
          validAddressAlerts {
            id
            alertType {
              id
              name
              alertLevel
            }
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
        }
        classification {
          id
          name
        }
        callTime
        incidentNumber
        officerIncidentSpecifics {
          id
          officer {
            id
            deptAttribute {
              id
              badge
              ori {
                id
                oriName
                abbreviation
              }
            }
          }
        }
        personIncidentSpecifics {
          id
          sealed
          juvenile
          yoe
          person {
            id
            aliases {
              id
              target {
                id
                validPersonAlerts {
                  id
                  alertType {
                    id
                    name
                    alertLevel
                  }
                }
              }
            }
            validPersonAlerts {
              alertType {
                id
                name
                alertLevel
              }
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
        }
      }
      incidentInvolvement {
        id
        name
      }
    }
  }
`;
